export default "__VITE_PUBLIC_ASSET__332f8091__"